import React from 'react';
import { useSearchParams } from 'react-router-dom';
import StudySentencesPage from './StudySentencesPage';
import BookSentencesListPage from '../book/BookSentencesListPage';

const StudySentencesSwitcher = () => {
  const [searchParams] = useSearchParams();
  const bookId = searchParams.get('bookid') || searchParams.get('bookId');

  if (bookId) {
    return <BookSentencesListPage />;
  }

  return <StudySentencesPage />;
};

export default StudySentencesSwitcher;

